import React, { useState } from 'react';
import HiveHero from '../../components/EdcHive/HiveHero/HiveHero';
import HiveInfoBlock from '../../components/EdcHive/HiveInfoBlock/HiveInfoBlock';
import HiveMasterclass from '../../components/EdcHive/HiveMasterclass/HiveMasterclass';
import HivePricing from '../../components/EdcHive/HivePricing/HivePricing';
import HiveEnquireForm from '../../components/EdcHive/HiveEnquireForm/HiveEnquireForm';
import MessageBox from '../../components/ForBrands/MessageBox/MessageBox';
import PurposeSection from '../../components/PurposeSection/PurposeSection';
import './EdcHive.css';

const getNavOffset = () => {
  const isMobile = window.innerWidth <= 768;
  const selectors = isMobile
    ? ['.mobile-navbar', '.mobile-navbar-background']
    : ['.navbar', '.navbar-background'];

  return selectors.reduce((offset, selector) => {
    const element = document.querySelector(selector);
    if (!element) return offset;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return offset;
    }

    return Math.max(offset, element.getBoundingClientRect().bottom);
  }, 0);
};

const scrollToEnquireForm = () => {
  const target =
    document.getElementById('hive-enquire') ||
    document.getElementById('hive-enquire-heading');
  if (!target) return;

  const navOffset = getNavOffset() || 88;
  const scrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;
  const top = Math.max(
    0,
    target.getBoundingClientRect().top + scrollTop - navOffset - 12
  );

  target.scrollIntoView({ block: 'start', behavior: 'auto' });
  window.scrollTo(0, top);
  document.documentElement.scrollTop = top;
  document.body.scrollTop = top;
};

const EdcHive = () => {
  const [selectedPackage, setSelectedPackage] = useState('');

  const handleEnquire = packageName => {
    setSelectedPackage(packageName);
    window.setTimeout(scrollToEnquireForm, 0);
    window.setTimeout(scrollToEnquireForm, 120);
    window.setTimeout(scrollToEnquireForm, 320);
  };

  return (
    <div className="edc-hive-page">
      <section className="edc-hive-hero-wrapper">
        <div className="container">
          <HiveHero />
          <HiveInfoBlock />
        </div>
      </section>

      <section className="edc-hive-masterclass-wrapper">
        <div className="container">
          <HiveMasterclass />
        </div>
      </section>

      <section className="edc-hive-pricing-wrapper">
        <div className="container">
          <HivePricing onEnquire={handleEnquire} />
        </div>
      </section>

      <section className="edc-hive-enquire-wrapper" id="hive-enquire">
        <div className="container">
          <HiveEnquireForm selectedPackage={selectedPackage} />
        </div>
      </section>

      <section className="edc-hive-message-wrapper">
        <div className="container">
          <MessageBox />
        </div>
      </section>

      <section className="edc-hive-purpose-wrapper">
        <div className="container">
          <PurposeSection />
        </div>
      </section>
    </div>
  );
};

export default EdcHive;
